import { Monitor, Laptop, Search } from "lucide-react";
import { fmtIdle } from "@/lib/api";
import { ConnBars } from "@/components/ConnBars";

const Badge = ({ cls, children, id }) => <span className={`ml-2 text-[10px] text-white rounded px-1.5 shrink-0 ${cls}`} data-testid={id}>{children}</span>;

export const Row2 = ({ m, group, selected, checked, onCheck, onSelect, onOpen, help, outdated }) => {
  const mac = m.os && m.os !== "Windows";
  const OsIcon = mac ? Laptop : Monitor;
  return (
    <div data-testid={`machine-row-${m.machine_id}`} onClick={(e) => e.detail === 1 && onSelect(m)} onDoubleClick={() => onOpen(m)}
      className={`group px-3 py-2 border-b border-slate-100 flex items-center gap-3 cursor-pointer select-none ${selected ? "bg-sky-50 shadow-[inset_3px_0_0_#0284c7]" : "hover:bg-slate-50"}`}>
      <input type="checkbox" checked={!!checked} onClick={(e) => e.stopPropagation()} onDoubleClick={(e) => e.stopPropagation()} onChange={() => onCheck(m)} className="h-3.5 w-3.5 accent-sky-600 cursor-pointer" data-testid={`machine-check-${m.machine_id}`} />
      <div className={`h-8 w-8 rounded-md flex items-center justify-center shrink-0 ${m.online ? "bg-emerald-50 text-emerald-600" : "bg-slate-100 text-slate-400"}`}><OsIcon className="h-4 w-4" /></div>
      <div className="flex-1 min-w-0 text-[12.5px] leading-[18px]">
        <p className="font-semibold text-slate-900 flex items-center min-w-0" data-testid={`machine-name-${m.machine_id}`}>
          {outdated && <span className="inline-block h-2 w-2 rounded-full bg-red-500 mr-1.5 shrink-0" title={`Agent ${m.agent_version || "inconnu"} : à mettre à jour`} data-testid={`machine-outdated-dot-${m.machine_id}`} />}
          <span className="truncate">{m.display_name || m.hostname}</span>
          {help && <Badge cls="bg-orange-500" id={`machine-help-badge-${m.machine_id}`}>Aide</Badge>}
          {m.in_session && <Badge cls="bg-sky-600">En session</Badge>}
          {m.uninstall_requested_at && <Badge cls="bg-slate-700" id={`machine-uninstall-badge-${m.machine_id}`}>Désinstallation</Badge>}
        </p>
        <p className="text-slate-500 truncate">{group?.name || "Non classé"}</p>
        <p className="text-slate-500 truncate">{m.username || "—"}{m.online ? ` · inactif ${fmtIdle(m.idle_s)}` : " · hors ligne"}</p>
      </div>
      <ConnBars m={m} compact />
    </div>
  );
};

export const SORTS = { name: "nom", online: "en ligne", group: "client" };
export const sortMachines = (list, by, groupMap) => {
  const n = (m) => (m.display_name || m.hostname || "").toLowerCase();
  const key = { name: n, online: (m) => `${m.online ? 0 : 1}${n(m)}`, group: (m) => `${(groupMap[m.group_id]?.name || "~").toLowerCase()}${n(m)}` }[by];
  return [...list].sort((a, b) => (key(a) < key(b) ? -1 : 1));
};

export const MachineList2 = ({ title, count, q, setQ, sort, setSort, allChecked, someChecked, toggleAll, toolbar, bulk, children }) => (
  <section className="w-[400px] flex-shrink-0 bg-white border-r border-slate-200 flex flex-col min-h-0" data-testid="machine-list">
    <div className="flex items-center gap-2 px-3 h-11 border-b border-slate-200 text-[12px] text-slate-600">
      <input type="checkbox" checked={allChecked} disabled={!count} onChange={toggleAll} title="Tout sélectionner" className="h-3.5 w-3.5 accent-sky-600 cursor-pointer" data-testid="machines-check-all"
        ref={(el) => { if (el) el.indeterminate = !allChecked && someChecked; }} />
      <span className="font-semibold text-slate-900 truncate" data-testid="list-title">{title}</span>
      <span className="shrink-0" data-testid="list-count">· {count}</span>
      <div className="ml-auto flex items-center gap-1 shrink-0">
        {toolbar}
        <select value={sort} onChange={(e) => setSort(e.target.value)} data-testid="sort-select" className="h-7 rounded-md border border-slate-200 px-1.5 text-[12px] text-slate-600 bg-white">
          {Object.entries(SORTS).map(([k, l]) => <option key={k} value={k}>Trier : {l}</option>)}
        </select>
      </div>
    </div>
    <div className="px-3 py-2 border-b border-slate-200">
      <label className="flex items-center gap-2 rounded-md border border-slate-200 px-2.5 h-8 text-[13px] text-slate-400 focus-within:border-sky-500">
        <Search className="h-4 w-4 shrink-0" />
        <input data-testid="search-machine-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder={`Rechercher dans ${title}`}
          className="flex-1 min-w-0 bg-transparent outline-none text-slate-900 placeholder:text-slate-400" />
      </label>
    </div>
    {bulk}
    <div className="flex-1 overflow-y-auto">{children}</div>
  </section>
);
